export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/367d6373b2e4d9c17cf51462a606388afef4aebc/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"